import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../../../viewer/input-handler';
import { DesignTool, DesignToolDialogState } from '../../../../../../../viewer/tools/design-tool';
import { InputDialog } from '../../../../../input-dialog/input-dialog';
import { CreateDesignTextDialog } from '../../../../../skyview-new/asset-menu/dialogs/create-design-text-dialog';
import { CreatePointByCoordinateDialog, CreatePointByOffsetDialog } from './create-point-dialogs';
import { DesignToolSaveDialog } from './save-dialog';

type Props = {
  tool: DesignTool;
  state: DesignToolDialogState;
};

const DesignToolDialogs = (props: Props) => {
  const { t } = useTranslation();

  if (props.state === DesignToolDialogState.SetName) {
    return (
      <InputDialog
        initialValue={props.tool.asset.name}
        title={t('saveDialog.headerNameModel', { ns: 'skyviewDesign' })}
        valueType="text"
        width={350}
        onCancel={async () => {
          props.tool.uiState = DesignToolDialogState.None;
          return Promise.resolve();
        }}
        onConfirm={async (value) => {
          props.tool.asset.name = value;
          props.tool.uiState = DesignToolDialogState.Saving;
          return Promise.resolve();
        }}
      />
    );
  }

  if (props.state === DesignToolDialogState.Abort || props.state === DesignToolDialogState.Saving) {
    const closeOnSave = props.tool.uiState === DesignToolDialogState.Abort;
    return (
      <DesignToolSaveDialog
        showAbortConfirmation={props.tool.uiState === DesignToolDialogState.Abort}
        tool={props.tool}
        onCancel={() => {
          props.tool.onDialogClose();
        }}
        onConfirm={async (wasSaved) => {
          if (wasSaved) {
            props.tool.onSaveDialogSaved();

            if (closeOnSave) {
              InputHandler.instance.setTool('select');
            }
          } else {
            await props.tool.onSaveDialogDiscardChanges();
          }
        }}
      />
    );
  }

  if (props.state === DesignToolDialogState.CreatePointByCoordinate) {
    return <CreatePointByCoordinateDialog tool={props.tool} />;
  }

  if (props.state === DesignToolDialogState.CreatePointByOffset) {
    return <CreatePointByOffsetDialog tool={props.tool} />;
  }

  return (
    <>
      <CreateDesignTextDialog tool={props.tool} />
    </>
  );
};

export { DesignToolDialogs as DesignToolDialogs };
